module.exports = __webpack_public_path__ + "static/faballey-4f8ed391f755eb65dfd7d0f4579a31ba.png";